// copied from http://wiki.vipkid.com.cn/display/VPS/OCFE+SDK#OCFESDK-%EF%BC%883%EF%BC%89%E4%BA%8B%E4%BB%B6
export default {
  TEACHER_ENTER_ROOM: "TEACHER_ENTER_ROOM",
  TEACHER_LEAVE_ROOM: "TEACHER_LEAVE_ROOM",
  USER_ROOM_KICKOFF: "USER_ROOM_KICKOFF",
  CHAT_MESSAGE: "CHAT_MESSAGE",
  BOARD_MESSAGE: "BOARD_MESSAGE",
  INIT_BOARD_MESSAGE: "INIT_BOARD_MESSAGE",
  INIT_USENUM: "INIT_USENUM",
  INIT_SILENCE: "INIT_SILENCE",
  GET_USER_NUMBER: "GET_USER_NUMBER",
  EXPORT_OUT: "EXPORT_OUT",
  SIGNAL_RECONNECT: "SIGNAL_RECONNECT",
  BOARD_PPT_PRESENTATION_CHANGED: "BOARD_PPT_PRESENTATION_CHANGED",
  BOARD_PPT_SLIDE_CHANGE: "BOARD_PPT_SLIDE_CHANGE",
  BOARD_PPT_DRAW_LINE: "BOARD_PPT_DRAW_LINE",
  BOARD_PPT_CLEAR: "BOARD_PPT_CLEAR",
  PUBLIC_VOTE_MESSAGE: "PUBLIC_VOTE_MESSAGE",
  TRANSPORT_DATA: "TRANSPORT_DATA"
}
